import Vue from 'vue'
import Router from 'vue-router'
/* module */
import Local from '@/app/module/local'
import Session from './app/module/session'
import { userType, common } from '@/app/model/store/domain/const'
/* plugin */
import VueGoogleCharts from 'vue-google-charts'

Vue.use(Router)
Vue.use(VueGoogleCharts)

declare module 'vue-router/types/router' {
  interface VueRouter {
    go(n: number|{[key: string]: string|boolean}) : void
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: 'field',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      redirect: 'field',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: {
        loginAuth: true,
        title: 'ログイン | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-reminder',
      name: 'password-reminder',
      component: () => import('./views/PasswordReminder.vue'),
      meta: {
        loginAuth: true,
        title: 'パスワードリマインダー | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-reminder/complete',
      name: 'password-reminder-complete',
      component: () => import('./views/Complete.vue'),
      meta: {
        reminderFlag: true,
        loginAuth: true,
        title: 'パスワードリマインダー | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-reminder/:uq_key',
      name: 'password-resetting',
      component: () => import('./views/PasswordResetting.vue'),
      meta: {
        loginAuth: true,
        title: 'パスワード再設定 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-resetting/complete',
      name: 'password-resetting-complete',
      component: () => import('./views/Complete.vue'),
      meta: {
        resettingFlag: true,
        loginAuth: true,
        title: 'パスワード再設定| ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/field',
      name: 'field',
      component: () => import('./views/Field.vue'),
      meta: {
        requiresAuth: true,
        title: 'マップ・圃場一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/field/order',
      name: 'field-order',
      component: () => import('./views/FieldOrder.vue'),
      meta: {
        requiresAuth: true,
        title: '収穫指示 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/field/:field_id',
      name: 'field-details',
      component: () => import('./views/FieldDetails.vue'),
      meta: {
        requiresAuth: true,
        title: '圃場詳細 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('./views/Account.vue'),
      meta: {
        authorityFlag: true,
        title: 'アカウント一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/account/create',
      name: 'account-create',
      component: () => import('./views/AccountCreate.vue'),
      meta: {
        authorityFlag: true,
        title: 'アカウント追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/account/:user_id',
      name: 'account-edit',
      component: () => import('./views/AccountEdit.vue'),
      meta: {
        authorityFlag: true,
        title: 'アカウント編集 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/variety',
      name: 'variety',
      component: () => import('./views/Variety.vue'),
      meta: {
        authorityFlag: true,
        title: '生育マスタ一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/variety/:variety_id',
      name: 'variety-edit',
      component: () => import('./views/VarietyEdit.vue'),
      meta: {
        authorityFlag: true,
        title: '生育マスタ編集 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/mypage',
      name: 'mypage',
      component: () => import('./views/MyPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'マイページ | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/profit',
      name: 'profit-prediction',
      component: () => import('./views/Profit.vue'),
      meta: {
        requiresAuth: true,
        title: '収益予測 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/error-page',
      name: 'error-page',
      component: () => import('./views/ErrorPage.vue'),
      meta: {}
    }
  ]
})

/*
 * ログインしていないユーザー処理
*/
router.beforeEach((to, from, next) => {
  let user = Local.getAuthToken()
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!requiresAuth) {
    next()
    return
  }

  /* ローカルストレージにユーザー情報がない場合、ログイン画面にリダイレクト */
  if (!user) {
    next({
      path: '/login'
    })
  } else {
    next()
  }
})

/*
 * ログインしているユーザーはログインページに飛ばさない
*/

router.beforeEach((to, from, loginNext) => {
  let user = Local.getAuthToken()
  let loginFlag = to.matched.some(record => record.meta.loginAuth)

  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!loginFlag) {
    loginNext()
    return
  }

  /* ログイン済みの場合はログイン画面へ飛ばさない */
  if (user) {
    loginNext({
      path: '/field'
    })
  } else {
    Session.clear()
    Local.clear()
    loginNext()
  }
})

router.beforeEach((to, from, resettingNext) => {
  let resetting = Local.getReminderFlag()
  let resettingFlag = to.matched.some(record => record.meta.completeFlag)

  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!resettingFlag) {
    resettingNext()
    return
  }

  if (!resetting || resetting === 'false') {
    resettingNext({
      path: '/password-reminder/:uq_key'
    })
  } else {
    resettingNext()
  }
})

router.beforeEach((to, from, manager) => {
  let user = Local.getAuthToken()
  let authority = parseInt(Local.getUserType()!)
  let authorityFlag = to.matched.some(record => record.meta.authorityFlag)

  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!authorityFlag) {
    manager()
    return
  }

  /* ローカルストレージにユーザー情報がない場合、ログイン画面にリダイレクト */
  if (!user) {
    manager({
      path: '/login'
    })
  } else {
    manager()
  }

  if (authority === userType.USER_TYPE_ADMIN) {
    authorityFlag = true
    manager()
  } else {
    authorityFlag = false
    manager({
      path: '/field'
    })
  }
})

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
